var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.563 99.3125C128.587 108.716 122.368 117.001 114.45 123.446C106.532 129.89 97.1554 134.296 87.1408 136.28C77.1262 138.263 66.7782 137.763 57.0015 134.824C47.2248 131.884 38.317 126.594 31.0569 119.417C23.7969 112.239 18.4057 103.392 15.3545 93.6497C12.3034 83.9072 11.6853 73.5655 13.5543 63.529C15.4233 53.4924 19.7224 44.0664 26.0759 36.0752C32.4293 28.0839 40.6436 21.7707 50.0006 17.6875",
    stroke: "#D9F5E7",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 75C137.5 66.7924 135.883 58.6651 132.742 51.0823C129.602 43.4994 124.998 36.6095 119.194 30.8058C113.391 25.0022 106.501 20.3984 98.9177 17.2575C91.3349 14.1166 83.2076 12.5 75 12.5V75H137.5Z",
    stroke: "#D9F5E7",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.4df5c8abae6d9ca316da3be833554d52.svg";
export { ForwardRef as ReactComponent };